import { useEffect } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import thdCustomer from '@thd-olt-global/thd-customer';
import * as helpers from '../components/InstantCheckoutHelper';
import { track } from '../components/analytics/instant-checkout-analytics';

export const useUserDetails = ({ itemId, storeId, isICRoadsDisabled = false }) => {
  const productOptions = {
    ssr: false,
    variables: {
      itemId,
      storeId,
    },
  };

  const {
    data: productData,
    loading: productLoading,
    error: productError,
  } = useDataModel('clientOnlyProduct', productOptions);
  const { fulfillment = {} } = productData?.product || {};

  const shouldFetchInstantCheckout =
    (thdCustomer.userID || thdCustomer.svocID) &&
    productData &&
    fulfillment &&
    helpers.isInstantCheckoutEligible(fulfillment, isICRoadsDisabled);

  const { THD_USER, THD_USER_SESSION } = helpers.getCookies(['THD_USER', 'THD_USER_SESSION']);

  let IC_ROADS = null;
  if (!isICRoadsDisabled) {
    IC_ROADS = helpers.getCookies(['IC_ROADS']);
  }

  const skipICRoadsFsOff = !!(!isICRoadsDisabled && !(THD_USER && THD_USER_SESSION && IC_ROADS));
  const skipICRoadsFsOn = !(THD_USER && THD_USER_SESSION);

  const {
    data: icData,
    loading: icLoading,
    error: icError,
  } = useDataModel('instantCheckout', {
    skip: !shouldFetchInstantCheckout || skipICRoadsFsOff || skipICRoadsFsOn,
    variables: {
      userId: thdCustomer.userID,
      customerAccountId: thdCustomer.svocID,
      thdUserCookie: THD_USER,
      icRoadsCookie: IC_ROADS || null,
    },
    context: {
      headers: {
        Authorization: THD_USER_SESSION,
      },
    },
  });

  useEffect(() => {
    if (productData && fulfillment) {
      if (
        !helpers.isInstantCheckoutEligible(fulfillment, isICRoadsDisabled) &&
        helpers.isGuestInstantCheckoutEligible(fulfillment)
      ) {
        track({ ICTemplate: 'DEFAULT' });
      }
    }
  }, [productData]);
  useEffect(() => {
    if (icData && !icError) {
      track({ ICTemplate: icData?.instantCheckout?.displayOption });
    }
  }, [icData, icLoading]);
  const ICModel = icData?.instantCheckout;

  return [
    {
      ICTemplate: ICModel?.displayOption || 'DEFAULT',
      addressCity: ICModel?.addressCity || '',
      addressZipCode: ICModel?.addressZipCode || '',
      xref: ICModel?.xref || '',
      displayCardBrand: ICModel?.displayCardBrand || '',
      loading: productLoading || icLoading,
    },
  ];
};
